import { useLearningUiTranslation } from '@features/learning/shared/use-learning-ui-translation'
import { useState } from 'react'
import type { FlashcardGameTemplateProps } from '../template-types'
import { compareFlashcardAnswer } from '../session-factory'
import { playLearningFeedbackAudio } from '@features/learning/shared/learning-feedback-audio'
import { Field, FieldLabel, LmsButton, LmsInput } from '@shared/ui'
import {
  LearningTemplateContinueActions,
  LearningTemplateExerciseFrame,
  LearningTemplatePromptMedia,
} from '@features/learning/shared/templates'
import '../flashcard-game.css'

export function Template4({
  onContinue,
  prompt,
}: FlashcardGameTemplateProps) {
  const ui = useLearningUiTranslation()
  const [value, setValue] = useState('')
  const [result, setResult] = useState<'correct' | 'incorrect' | null>(null)

  const handleCheckAnswer = () => {
    const nextResult = compareFlashcardAnswer({
      actual: value,
      expected: prompt.answerText ?? '',
    })
      ? 'correct'
      : 'incorrect'

    setResult(nextResult)
    playLearningFeedbackAudio(nextResult)
  }

  return (
    <LearningTemplateExerciseFrame
      className="flashcardGameTemplate"
      hint={prompt.promptLabel ? <p className="flashcardGameTemplateHint">{prompt.promptLabel}</p> : null}
      media={
        <LearningTemplatePromptMedia
          audio={prompt.audio}
          audioAutoPlayKey={prompt.id}
          audioAutoPlayOnLoad
          audioVariant="flashcard"
          className="flashcardGamePromptMedia"
          image={prompt.image}
          imageAlt={ui("Flashcard prompt")}
          showAdvancedAudioControls
        />
      }
      questionText={prompt.question}
      sourceOwner="flashcards"
    >
      <Field>
        <FieldLabel htmlFor="flashcard-template-4-answer">
          {ui("Type the flashcard title")}</FieldLabel>
        <LmsInput
          id="flashcard-template-4-answer"
          onChange={(event) => {
            setValue(event.target.value)
          }}
          value={value}
        />
      </Field>
      {result ? (
        <LearningTemplateContinueActions
          incorrectReviewText={prompt.answerText ?? null}
          incorrectReviewTranslationText={prompt.answerTranslation ?? null}
          onContinue={onContinue}
          result={result}
        />
      ) : (
        <LmsButton
          className="flashcardGameCheckAction"
          disabled={!value.trim()}
          onClick={handleCheckAnswer}
          variant="primary"
        >
          {ui("Check answer")}</LmsButton>
      )}
    </LearningTemplateExerciseFrame>
  )
}
